<template>
  <div class="scan-code bg-center"  :style="scanCodeStyle">
    <!-- 扫描量的曲线图, -->
    <div id="code-charts" :style="scanCodeStyle"></div>
    <div class="left-bg-title bg-center pd10tb">
		<img src="../../assets/images/icon4.png" class="icon"/>
		扫码量统计
	</div>
  </div>
</template>

<script>
//引入曲线图静态数据
// import scanCodeData from '../../assets/staticData/scanCodeData';
import {getOrgcodeData} from "../../api/region.js";
import {mapState} from "vuex";
export default { 
  data(){ 
	  return {
		scanCodeData:{
			xAxisData:[],
			seriesData:[]
		},
		timer:null,
		Dom:null
	  }
  },
  mounted() {
	this.Dom = document.getElementById("code-charts");  
  },
  watch:{
	async codeData(val)
	{
		console.log("val",val)
		if(val != '')
		{
			this.scanCodeData = {
				xAxisData:[],
				seriesData:[]
			};
			await val.forEach(item => {
				this.scanCodeData.xAxisData.push(item.date);
				this.scanCodeData.seriesData.push(item.scan_code)
			})
			if(typeof this.Dom != 'null') {
				this.setTime();
			}
			
		}
	}
  },
  computed: {
	...mapState(['codeData']),  
    //拿到左侧charts图表的公共样式,
    scanCodeStyle() {
       return this.$store.state.leftAreaChartsStyle
    },
	
  },
  methods: {
    //企业扫码信息,曲线图,
    scanDrawLine() {
      //初始化echarts实例,
      let scanDom = this.Dom;
      let scanChart = this.$echarts.init(scanDom);
	  scanChart.clear();
      //绘制图表,
      let option = {
		animationDuration: 3000,
        tooltip: {
          //鼠标悬浮显示
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "#87C93E"
            }
          }
        },
        grid: {
          //曲线图盒子样式
          left: "6%",
          top: "18%",
          right: "6%",
          bottom: "8",
          containLabel: true
        },
        xAxis: [
          {
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                //底部日期字体样式
                color: "rgba(255,255,255,.5)",
                fontSize: 10
              }
            },
            data: this.scanCodeData.xAxisData //底部日期
          }
        ],
        yAxis: [
          {
            axisLine: {
              lineStyle: {
                color: "#4A5675"
              }
            },
            name: "20%",
            type: "value",
            splitLine: {
              show: false
            },
            scale: true,
            axisLabel: {
              //右侧刻度样式
              textStyle: {
                color: "rgba(255,255,255,.5)",
                fontSize: 10
              }
            }
          }
        ],
        series: [
          {
            name: "扫码量",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 5,
            showSymbol: true,
            itemStyle: {
              normal: {
                color: "#87C93E", //鼠标悬浮颜色
                borderColor: "#87C93E",
                borderWidth: 12
              }
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(1, 132, 213, 0.4)"
                    },
                    {
                      offset: 0.8,
                      color: "rgba(1, 132, 213, 0.1)"
                    }
                  ],
                  false
                ),
                shadowColor: "rgba(0, 0, 0, 0.1)"
              }
            },
            data: this.scanCodeData.seriesData
          }
        ]
      };
      scanChart.setOption(option);
    },
	
	setTime() {
		this.scanDrawLine()
		let nowTime = new Date();
		let that = this;
		this.clearTimer();
		this.timer = setTimeout(function() {
			if(new Date() - nowTime > 800)
			{
				that.setTime()
			}
		}, 6000);
	},
	//清除定时
	clearTimer()
	{
		clearInterval(this.timer);
		this.timer = null;
	}
  }
};
</script>

<style lang='less'>
.scan-code {
  position: relative;
  background-image: url('../../assets/images/middle-bg.png');
  //设置title样式
}
.left-bg-title{
    background: none;
    line-height: 20px;
    left: 10px;
    top: 7px;
	color: #4FCCFF;
}
.left-bg-title .icon{
	width: 20px;
	height: 20px;
	float: left;
	margin-right: 8px;
}
</style>